<template lang="pug">
  .make-an-entry-mindfulness
    .make-an-entry-content
      MakeAnEntryVisibility(text="Always Private")
      section.section.pb-1.pt-2.mt-2
        WtTitle(h4 bold style="margin-bottom:5px") Mindfulness
        WtLabel(
          style="color:#756E7A"
          text="How many mindfulness sessions did you practice today?"
        )
        .is-flex.mt-5
          BButton.session-button.mt-5.mr-3(
            @click.native="sessions = sessions - 1"
            :disabled="sessions === 0"
          )
            BIcon(icon="minus" size="is-small")
          .is-flex.is-flex-direction-column.is-align-items-center
            .mindfulness-plant-wrapper
                WtSvgIcon.leaf.leaf-1(v-show="sessions < 1" icon="mindfulness_plant/leaf_01_off" width="62px" height="44px")
                WtSvgIcon.leaf.leaf-3(v-show="sessions < 3" icon="mindfulness_plant/leaf_03_off" width="45px" height="62px")
                WtSvgIcon.leaf.leaf-5(v-show="sessions < 5" icon="mindfulness_plant/leaf_05_off" width="30px" height="35px")
                WtSvgIcon.leaf.leaf-4(v-show="sessions < 4" icon="mindfulness_plant/leaf_04_off" width="41px" height="48px")
                WtSvgIcon.leaf.leaf-2(v-show="sessions < 2" icon="mindfulness_plant/leaf_02_off" width="62px" height="44px")
                WtSvgIcon.leaf.leaf-1(v-show="sessions >= 1" icon="mindfulness_plant/leaf_01_on" width="62px" height="44px")
                WtSvgIcon.leaf.leaf-3(v-show="sessions >= 3" icon="mindfulness_plant/leaf_03_on" width="45px" height="62px")
                WtSvgIcon.leaf.leaf-5(v-show="sessions >= 5" icon="mindfulness_plant/leaf_05_on" width="30px" height="35px")
                WtSvgIcon.leaf.leaf-4(v-show="sessions >= 4" icon="mindfulness_plant/leaf_04_on" width="41px" height="48px")
                WtSvgIcon.leaf.leaf-2(v-show="sessions >= 2" icon="mindfulness_plant/leaf_02_on" width="62px" height="44px")
            .session-number.is-size-6.has-text-dark.mt-4 {{ sessions }} {{ sessions === 1 ? "session" : "sessions" }}
          BButton.session-button.mt-5.ml-3(
            type="is-primary"
            @click.native="sessions < 20 ? sessions = sessions + 1 : null"
            :disabled="sessions === 20"
          )
            BIcon(icon="plus")
        MakeAnEntryTip(:tip-category="'mindfulness'")
    .level.is-mobile.program-settings-form-controls
      .level-left
      .level-right
        .level-item
          WtButton(
            is-text
            color="white"
            style="text-decoration:none"
            size="medium"
            @click.native="reset"
            :disabled="disableReset"
          ) Reset
        .level-item
          WtButton(@click.native="saveEntry" :loading="savingMindfulness" :disabled="disableSave") SAVE
</template>

<script>
import { mapActions } from "vuex";
import MakeAnEntryFooter from "@@/Members/MakeAnEntry/MakeAnEntryFooter";
import MakeAnEntryVisibility from "@@/Members/MakeAnEntry/MakeAnEntryVisibility";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import MakeAnEntryTip from "@@/Members/MakeAnEntry/MakeAnEntryTip";
import WtLabel from "@@/WtLabel/WtLabel";

export default {
  name: "MakeAnEntryMindfulness",
  components: {
    WtTitle,
    WtButton,
    MakeAnEntryFooter,
    WtSvgIcon,
    MakeAnEntryTip,
    MakeAnEntryVisibility,
    WtLabel
  },
  props: {
    uniqueKey: {
      type: String,
      default: null
    },
    fetchAction: {
      type: Function,
      default: () => {},
      required: true
    },
    entryItem: {
      type: Object,
      default: () => {},
      required: true
    },
    entryDate: {
      type: String,
      default: ""
    },
    formData: {
      type: FormData,
      required: true,
      validator: value => {
        return value instanceof FormData;
      }
    },
    saveEntryWrapper: {
      type: Function,
      required: true
    },
    disableSave: {
      type: Boolean,
      default: true
    },

    disableReset: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      sessions: 0,
      savingMindfulness: false
    };
  },

  computed: {
    currentMetricValue() {
      let metric = this._.find(this.entryItem.wellnessMetrics, {
        type: "mindfulness"
      });
      return this._.get(metric, "value", 0);
    },

    setFormData() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.sessions !== this.currentMetricValue ||
          this.formData.has("mindfulness")
        );
      }
      return true;
    }
  },

  watch: {
    sessions() {
      if (this.setFormData) {
        this.formData.set("mindfulness", this.sessions);
        this.$emit("formDataUpdated", true);
      }
    }
  },

  mounted() {
    this.sessions = this.currentMetricValue;
  },

  methods: {
    ...mapActions("members", ["storeJournal", "updateJournal"]),

    saveEntry() {
      this.savingMindfulness = true;
      this.saveEntryWrapper(this.storeJournal, this.updateJournal);
    },

    reset() {
      const item = "mindfulness";
      if (this.formData.has(item)) {
        this.formData.delete(item);
      }
      this.mindfulness = this.currentMetricValue;
      this.sessions = this.mindfulness;
      this.$nextTick(() => {
        this.$emit("formReset", true);
      });
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-mindfulness
  .wellness-visibility
    position: absolute
    right: 1rem
    top: .5rem
  .session-button
    width: 30px
    height: 30px
    border-radius: 15px
    padding: 0
    .icon
      display: flex
  .session-number
    padding: 0.2rem 1.2rem
    border: 1px solid $white-bis
    border-radius: 5px
    background-color: $white
  .mindfulness-plant-wrapper
    position: relative
    height: 75px
    width: 123px
    .leaf-1,
    .leaf-2,
    .leaf-3,
    .leaf-4,
    .leaf-5
      position: absolute
    .leaf-1
      left: 0
      bottom: 0
      z-index: 3
    .leaf-2
      right: 0
      bottom: 0
      z-index: 3
    .leaf-3
      left: 21px
      bottom: 4px
      z-index: 2
    .leaf-4
      right: 21px
      bottom: 18px
      z-index: 2
    .leaf-5
      left: 46px
      bottom: 40px
      z-index: 1
.program-settings-form-controls
  margin-top: 20px
</style>
